import keymirror from 'keymirror'

export const ANALYTICS_EVENTS = keymirror({
  page_view: null,
  sign_in: null,
  sign_out: null,
})
